import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SingleDatePicker } from "sarsaparilla";

import styles from './DateInput.scss';
import pageStyles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  label: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  value: ''
};

export default class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    };
  }

  render() {
    const id = `mod_${this.props.field.replace('.', '_')}`;
    const label = !this.props.label ? null : (
      <label htmlFor={id}>{this.props.label}</label>
    );
    const css = `${pageStyles["text-input"]} ${this.props.required ? pageStyles.required : ""} ${this.props.fullWidth ? pageStyles["full-width"] : ""} ${styles["date-input-wrapper"]}`;
    return (
      <div className={css}>
        {label}
        <SingleDatePicker
          id={id}
          date={moment(this.props.value)}
          focused={this.state.focused}
          numberOfMonths={1}
          showDefaultInputIcon
          isOutsideRange={() => false}
          onDateChange={(date) => this.props.onChange(date.format())}
          onFocusChange={
            () => this.setState({focused: !this.state.focused})
          } />
      </div>
    );
  }
}

DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;
